module.exports = __webpack_public_path__ + "static/img/rank-1.4f590f87.png";